import apiService from './apiService';
import { GET } from './executer';

export interface RainPathData {
  timestamp: string;
  direction_deg: number;
  speed_kmh: number;
  circuit: { lat: number; lon: number };
  drawable?: boolean;
  cell_found?: boolean;
  fallback_used?: boolean;
  motion_quality?: {
    pairs_total: number;
    pairs_valid: number;
    direction_spread_deg: number;
    speed_spread_kmh: number;
  };
  cell?: {
    cell_area_km2: number;
    cell_max_dbz: number;
    cell_mean_dbz: number;
    cell_distance_km: number;
    cell_bearing_deg: number;
  };
}

interface RainPathRangeQuery {
  start_timestamp: string; // YYYYMMDDHHmmss (UTC)
  end_timestamp: string;   // YYYYMMDDHHmmss (UTC)
}

class RainPathService {
  async getRainPathRange(query: RainPathRangeQuery): Promise<RainPathData[]> {
    const { start_timestamp, end_timestamp } = query;

    const queryParams = new URLSearchParams({ start_timestamp, end_timestamp });

    const response = await apiService.client.execute<RainPathData[]>(
      GET,
      `/api/rain-path-l2?${queryParams.toString()}`
    );

    if (!response.success) {
      console.warn('[RainPathService] Failed to fetch rain path range:', response);
      return [];
    }

    return response.data ?? [];
  }
}

const rainPathService = new RainPathService();
export default rainPathService;

export type { RainPathRangeQuery };
